<template lang="pug">
.form-faq.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container(v-if="fillData")
        input.input(v-model="dataForm.faq" autocomplete="ño" disabled required)
        label.label(:class="{ show: dataForm.faq }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="faq" title="ID")

      .input-container
        input.input(v-model="dataForm.question" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.question }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="question" title="Pregunta" :caseSensitive="true")

      .input-container
        label.label(:class="{ show: dataForm.answer }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="answer" title="Respuesta" :caseSensitive="true" :hideModified="true")
        textarea.input(v-model="dataForm.answer" autocomplete="ño" rows="5" required)

      .input-container.arrow
        select.select(v-model="dataForm.brand" autocomplete="ño" :disabled="fillData" required)
          option(v-for="brand in brands" :key="brand" :value="brand") {{ brand }}
        label.label(:class="{ show: dataForm.brand }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="brand" title="Marca")

      .input-container.arrow
        select.select(v-model="dataForm.active" autocomplete="ño" required)
          option(:value="true") Activo
          option(:value="false") Inactivo
        label.label(:class="{ show: dataForm.active === true || dataForm.active === false }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="active" title="Estado")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteFaq")
</template>

<script>
import gql from '@my/graphql'
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlFaq from '@/graphql/faq'
import shDeleteButton from '@/components/elements/DeleteButton'
import shProperty from '@/components/elements/Property'
import modals from '@my/store/modals'
import msg from '@/config/messages'
import filters from '@/config/filters'

export default {
  name: 'FormFaq',

  mixins: [mForm, mDB],

  components: { shDeleteButton, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        question: '',
        answer: '',
        brand: '',
        active: true
      },
      resolver: 'faq',
      key: 'faq',
      gql: gqlFaq
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newFaq()
      } else {
        this.updateFaq()
      }
    },

    newFaq () {
      this.newData(this.gql, this.resolver, this.key)
    },

    async updateFaq () {
      const dataUpdate = this.dataUpdate()

      if (!dataUpdate) {
        modals.showMessage({ message: msg.message.all.NOTHING_CHANGED.message, type: 'error' })
        return
      }

      const variables = {
        faq: this.dataOriginal.faq,
        brand: this.dataOriginal.brand,
        faqUpdate: dataUpdate
      }

      const response = await gql.mutate(this.gql.UPDATE, variables)

      if (response) {
        const dataUpdated = response.data[`update${filters.capitalize(this.resolver)}`]
        modals.showMessage({ message: msg.message.default.UPDATED.message(dataUpdated[this.key], this.resolver) })
      }
    },

    async deleteFaq () {
      const variables = {
        faq: this.dataOriginal.faq,
        brand: this.dataOriginal.brand
      }

      const response = await gql.mutate(this.gql.DELETE, variables)

      if (response) {
        const dataDeleted = response.data[`delete${filters.capitalize(this.resolver)}`]
        modals.showMessage({ message: msg.message.default.DELETED.message(dataDeleted[this.key], this.resolver) })
      }
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-faq
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/faq/Form.vue